// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "5b6a48f03f2ae4b294b0" + ".chunk.js";
};